// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.galleryWrapper__Me4oR {
  padding: 15px 15px 30px;
  display: flex;
  flex-direction: column;
  row-gap: 15px;
  background-color: var(--tables-photo-gallery-surface);
  position: relative;
  overflow: hidden;
  border-radius: 4px;
}
@media (max-width: 999px) {
  .galleryWrapper__Me4oR {
    padding-bottom: 35px;
  }
}
@media print {
  .galleryWrapper__Me4oR {
    overflow: auto;
  }
}

.gallery__jJYIB {
  height: 90px;
  width: 100%;
  position: relative;
  overflow: visible;
}
@media (min-width: 999px) {
  .gallery__jJYIB {
    height: auto;
    overflow: initial;
  }
  .gallery__jJYIB .swiper-wrapper {
    max-height: 315px;
  }
  .gallery__jJYIB .swiper-slide {
    height: 315px;
    opacity: 0;
    transition: opacity 0.3s cubic-bezier(0.47, 0, 0.745, 0.715);
    pointer-events: none;
  }
  .gallery__jJYIB .swiper-slide.swiper-slide-active {
    opacity: 1;
    pointer-events: auto;
    cursor: zoom-in;
  }
}
.gallery__jJYIB .swiper-pagination {
  display: flex;
  column-gap: 7px;
  position: absolute;
  bottom: -16px !important;
  left: 50% !important;
  transform: translateX(-50%);
  z-index: 2;
  width: auto !important;
}
.gallery__jJYIB .swiper-pagination-bullet {
  width: 9px;
  height: 3px;
  display: block;
  padding: 0;
  background: var(--tables-photo-gallery-pagination-default);
  transform: none;
  border: none;
  border-radius: 0;
  box-shadow: none;
  opacity: 1;
  cursor: pointer;
}
.gallery__jJYIB .swiper-pagination-bullet.swiper-pagination-bullet-active {
  width: 11px;
  background: var(--tables-photo-gallery-pagination-active);
  border: none;
  cursor: auto;
}
.gallery__jJYIB .swiper-slide {
  opacity: 0;
  transition: opacity 0.3s cubic-bezier(0.47, 0, 0.745, 0.715);
  pointer-events: none;
}
@media (max-width: 998px) {
  .gallery__jJYIB .swiper-slide.swiper-slide-active, .gallery__jJYIB .swiper-slide.swiper-slide-active + .swiper-slide, .gallery__jJYIB .swiper-slide.swiper-slide-active + .swiper-slide + .swiper-slide {
    opacity: 1;
    pointer-events: auto;
    cursor: zoom-in;
  }
}
@media print {
  .gallery__jJYIB {
    height: 0;
    overflow: hidden;
  }
}

@media (min-width: 999px) {
  .equipmentGallery__PjYuc .swiper-wrapper {
    max-height: 335px;
  }
  .equipmentGallery__PjYuc .swiper-slide {
    height: 335px;
  }
}

.galleryImage__wlZom {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
@media (max-width: 999px) {
  .galleryImage__wlZom {
    max-height: 90px;
  }
}

.galleryNavigation__ou1em {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  top: 50%;
  z-index: 1;
}

.navBtn__mcKVc {
  width: 30px;
  height: 30px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--tables-photo-gallery-surface-arrow);
  border: none;
  position: absolute;
  top: 50%;
  z-index: 1;
  cursor: pointer;
}
.navBtn__mcKVc path {
  stroke: var(--tables-photo-gallery-icon);
}
@media (max-width: 999px) {
  .navBtn__mcKVc {
    width: 20px;
    top: 30px;
  }
}

.prevBtn__S6QQP {
  left: 0;
  border-radius: 0 2px 2px 0;
}

.prevBtnIcon__Rpe0F {
  width: 20px;
  height: 20px;
  transform: rotate(180deg);
}
.prevBtnIcon__Rpe0F path {
  stroke: var(--tables-photo-gallery-icon);
}

.nextBtn__dq5NP {
  right: 0;
  border-radius: 2px 0 0 2px;
}

.nextBtnIcon__HoN5s {
  width: 20px;
  height: 20px;
}
.nextBtnIcon__HoN5s path {
  stroke: var(--tables-photo-gallery-icon);
}

.editIconWrapper__l2FHs {
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--tables-photo-gallery-surface-arrow);
  border-radius: 4px;
  position: absolute;
  top: 19px;
  right: 19px;
  z-index: 2;
  cursor: pointer;
}

.editIcon__pwdQP {
  width: 24px;
  height: 24px;
}
.editIcon__pwdQP path {
  fill: var(--buttons-surface);
}

.printPhotosBlock__Zs_3R {
  display: none;
  height: 0;
  overflow: hidden;
}
@media print {
  .printPhotosBlock__Zs_3R {
    display: flex;
    flex-direction: column;
    height: auto;
  }
}

.printPhoto__q6Hi0 {
  width: 100%;
  height: 333px;
  object-fit: contain;
  margin-top: 15px;
}`, "",{"version":3,"sources":["webpack://./../src/components/common/Gallery/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,qDAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAzEF;AA2EE;EAVF;IAWI,oBAAA;EAxEF;AACF;AA0EE;EAdF;IAeI,cAAA;EAvEF;AACF;;AA0EA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;AAvEF;AA0EI;EADF;IAEI,YAAA;IACA,iBAAA;EAvEJ;EAyEI;IACE,iBAAA;EAvEN;EA0EI;IACE,aAAA;IACA,UAAA;IACA,4DAAA;IACA,oBAAA;EAxEN;EA0EM;IACE,UAAA;IACA,oBAAA;IACA,eAAA;EAxER;AACF;AA4EI;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,wBAAA;EACA,oBAAA;EACA,2BAAA;EACA,UAAA;EACA,sBAAA;AA1EN;AA6EI;EACE,UAAA;EACA,WAAA;EACA,cAAA;EACA,UAAA;EACA,0DAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;AA3EN;AA6EM;EACE,WAAA;EACA,yDAAA;EACA,YAAA;EACA,YAAA;AA3ER;AA+EI;EACE,UAAA;EACA,4DAAA;EACA,oBAAA;AA7EN;AA+EM;EACE;IAGE,UAAA;IACA,oBAAA;IACA,eAAA;EA/ER;AACF;AAoFE;EA9EF;IA+EI,SAAA;IACA,gBAAA;EAjFF;AACF;;AAsFI;EACE;IACE,iBAAA;EAnFN;EAsFI;IACE,aAAA;EApFN;AACF;;AAyFA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;AAtFF;AAwFE;EANF;IAOI,gBAAA;EArFF;AACF;;AAwFA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AArFF;;AAwFA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,2DAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;AArFF;AAuFE;EACE,wCAAA;AArFJ;AAwFE;EAlBF;IAmBI,WAAA;IACA,SAAA;EArFF;AACF;;AAwFA;EACE,OAAA;EACA,0BAAA;AArFF;;AAwFA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;AArFF;AAuFE;EACE,wCAAA;AArFJ;;AAyFA;EACE,QAAA;EACA,0BAAA;AAtFF;;AAyFA;EACE,WAAA;EACA,YAAA;AAtFF;AAwFE;EACE,wCAAA;AAtFJ;;AA0FA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,2DAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;AAvFF;;AA0FA;EACE,WAAA;EACA,YAAA;AAvFF;AAyFE;EACE,4BAAA;AAvFJ;;AA2FA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AAxFF;AA0FE;EALF;IAMI,aAAA;IACA,sBAAA;IACA,YAAA;EAvFF;AACF;;AA0FA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AAvFF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.galleryWrapper {\n  padding: 15px 15px 30px;\n  display: flex;\n  flex-direction: column;\n  row-gap: 15px;\n  background-color: var(--tables-photo-gallery-surface);\n  position: relative;\n  overflow: hidden;\n  border-radius: 4px;\n\n  @media (max-width: 999px) {\n    padding-bottom: 35px;\n  }\n\n  @media print {\n    overflow: auto;\n  }\n}\n\n.gallery {\n  height: 90px;\n  width: 100%;\n  position: relative;\n  overflow: visible;\n\n  :global {\n    @media (min-width: 999px) {\n      height: auto;\n      overflow: initial;\n\n      .swiper-wrapper {\n        max-height: 315px;\n      }\n\n      .swiper-slide {\n        height: 315px;\n        opacity: 0;\n        transition: opacity 0.3s cubic-bezier(0.47, 0, 0.745, 0.715);\n        pointer-events: none;\n\n        &.swiper-slide-active {\n          opacity: 1;\n          pointer-events: auto;\n          cursor: zoom-in;\n        }\n      }\n    }\n\n    .swiper-pagination {\n      display: flex;\n      column-gap: 7px;\n      position: absolute;\n      bottom: -16px !important;\n      left: 50% !important;\n      transform: translateX(-50%);\n      z-index: 2;\n      width: auto !important;\n    }\n\n    .swiper-pagination-bullet {\n      width: 9px;\n      height: 3px;\n      display: block;\n      padding: 0;\n      background: var(--tables-photo-gallery-pagination-default);\n      transform: none;\n      border: none;\n      border-radius: 0;\n      box-shadow: none;\n      opacity: 1;\n      cursor: pointer;\n\n      &.swiper-pagination-bullet-active {\n        width: 11px;\n        background: var(--tables-photo-gallery-pagination-active);\n        border: none;\n        cursor: auto;\n      }\n    }\n\n    .swiper-slide {\n      opacity: 0;\n      transition: opacity 0.3s cubic-bezier(0.47, 0, 0.745, 0.715);\n      pointer-events: none;\n\n      @media (max-width: 998px) {\n        &.swiper-slide-active,\n        &.swiper-slide-active + .swiper-slide,\n        &.swiper-slide-active + .swiper-slide + .swiper-slide {\n          opacity: 1;\n          pointer-events: auto;\n          cursor: zoom-in;\n        }\n      }\n    }\n  }\n\n  @media print {\n    height: 0;\n    overflow: hidden;\n  }\n}\n\n.equipmentGallery {\n  :global {\n    @media (min-width: 999px) {\n      .swiper-wrapper {\n        max-height: 335px;\n      }\n\n      .swiper-slide {\n        height: 335px;\n      }\n    }\n  }\n}\n\n.galleryImage {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n\n  @media (max-width: 999px) {\n    max-height: 90px;\n  }\n}\n\n.galleryNavigation {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: absolute;\n  top: 50%;\n  z-index: 1;\n}\n\n.navBtn {\n  width: 30px;\n  height: 30px;\n  padding: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--tables-photo-gallery-surface-arrow);\n  border: none;\n  position: absolute;\n  top: 50%;\n  z-index: 1;\n  cursor: pointer;\n\n  path {\n    stroke: var(--tables-photo-gallery-icon);\n  }\n\n  @media (max-width: 999px) {\n    width: 20px;\n    top: 30px;\n  }\n}\n\n.prevBtn {\n  left: 0;\n  border-radius: 0 2px 2px 0;\n}\n\n.prevBtnIcon {\n  width: 20px;\n  height: 20px;\n  transform: rotate(180deg);\n\n  path {\n    stroke: var(--tables-photo-gallery-icon);\n  }\n}\n\n.nextBtn {\n  right: 0;\n  border-radius: 2px 0 0 2px;\n}\n\n.nextBtnIcon {\n  width: 20px;\n  height: 20px;\n\n  path {\n    stroke: var(--tables-photo-gallery-icon);\n  }\n}\n\n.editIconWrapper {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--tables-photo-gallery-surface-arrow);\n  border-radius: 4px;\n  position: absolute;\n  top: 19px;\n  right: 19px;\n  z-index: 2;\n  cursor: pointer;\n}\n\n.editIcon {\n  width: 24px;\n  height: 24px;\n\n  path {\n    fill: var(--buttons-surface);\n  }\n}\n\n.printPhotosBlock {\n  display: none;\n  height: 0;\n  overflow: hidden;\n\n  @media print {\n    display: flex;\n    flex-direction: column;\n    height: auto;\n  }\n}\n\n.printPhoto {\n  width: 100%;\n  height: 333px;\n  object-fit: contain;\n  margin-top: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"galleryWrapper": `galleryWrapper__Me4oR`,
	"gallery": `gallery__jJYIB`,
	"equipmentGallery": `equipmentGallery__PjYuc`,
	"galleryImage": `galleryImage__wlZom`,
	"galleryNavigation": `galleryNavigation__ou1em`,
	"navBtn": `navBtn__mcKVc`,
	"prevBtn": `prevBtn__S6QQP`,
	"prevBtnIcon": `prevBtnIcon__Rpe0F`,
	"nextBtn": `nextBtn__dq5NP`,
	"nextBtnIcon": `nextBtnIcon__HoN5s`,
	"editIconWrapper": `editIconWrapper__l2FHs`,
	"editIcon": `editIcon__pwdQP`,
	"printPhotosBlock": `printPhotosBlock__Zs_3R`,
	"printPhoto": `printPhoto__q6Hi0`
};
module.exports = ___CSS_LOADER_EXPORT___;
